import { useMsal } from "@azure/msal-react";
import { loginRequest, renewToken } from "./authConfig.jsx";
import { environment } from "../environments/environment";
import { getMsalErrorMsg } from "../utils/msalErrorCodes";
import axios from "axios";



export const checkAndRenewToken = () => {
  const expirationTime = parseInt(localStorage.getItem("session_Exp_tok"), 10);

  if (!expirationTime || isNaN(expirationTime)) {
    console.error("Expiration time is invalid or not set. Renewing token immediately...");
    renewToken();
    return;
  }

  const timeLeft = expirationTime - Date.now();

  if (timeLeft <= 0) {
    console.warn("Token has already expired. Renewing immediately...");
    renewToken();
  } else if (timeLeft <= 20 * 60 * 1000) {
    console.warn("Renewing token because it is about to expire...");
    renewToken();
  } else {
    setTimeout(() => renewToken(), timeLeft - 20 * 60 * 1000);
  }
};


export const setAuthCookie = (name, value) => {
  const date = new Date();
  date.setTime(date.getTime() + 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value}; ${expires}; secure`;

};

export const saveUserDataInLocal = (
  username,
  email,
  id,
  companyId,
  companyName,
  companies,
  accountId
) => {

  if (username && email && id
    && companyId && companyName && companies && accountId
  ) {
    localStorage.setItem("u_name", username);
    localStorage.setItem("u_email", email);
    localStorage.setItem("u_id", id);
    localStorage.setItem("u_company_id", companyId);
    localStorage.setItem("u_company_name", companyName);
    localStorage.setItem("u_companies", JSON.stringify(companies));
    localStorage.setItem("u_account_id", accountId);

  } else {
    throw new Error(
      "Something went wrong trying to save user data"
     , Error);
  }
};

export const getUserInfo = () => {
  return axios.get(environment.getUserInfo);
};

export const updateInfoCompanies = (body) => {
  return axios.post(environment.updateInfoCompanies, body);
};
export const getAnchoredResourceByUser = (companyId) => {
  return axios.get(environment.getAnchoredResourceByUser+"?companyId=" + companyId);
};

export const updateHistoryNavigation = (tab) => {

  return axios.post(environment.updateHistoryNavigation, tab)

}

export const getRecentNavigation = (page, pageSize) => {
  return axios.get(environment.getRecentNavigation+"?page=" + page + "&pageSize=" + pageSize);
};

export const saveRecentSearch = (item) => {
  return axios.post(environment.saveRecentSearch, item);
};

export const getRecentSearch = () =>{
  return axios.get(environment.getRecentSearch)
}

export const getGlobalSearchResults= (searchCriteria) =>{
  return axios.get(environment.getGlobalSearchResults+"?searchCriteria=" + searchCriteria,
    { hideLoader: true });
}

export const getGlobalSearchFiles= (searchCriteria) =>{
  return axios.get(environment.getGlobalSearchFiles+"?searchCriteria=" + searchCriteria,
    { hideLoader: true });
}

export const saveAnchoredResource = (isPinned, itemId, isModule) => {
  let companyId = parseInt(localStorage.getItem("u_company_id"));
  const userId = getUserId();
  return axios.request({
    method: "POST",
    url: environment.saveAnchoredResource,
    data:
      {
        userId: userId,
        companyId: companyId,
        resourceId: isModule ? null : itemId,
        moduleId: isModule ? itemId : null,
        isAnchored: isPinned,
        isModule: isModule,
      },
  });
}

export const getUserId = () => {
  const id = localStorage.getItem("u_id");
  if (id) {
    return id;
  } else {
    return null;
  }
}

export const getUserCompanyName = () => {
  const company = localStorage.getItem("u_company_name");
  if (company) {
    return company;
  } else {
    return null;
  }
}


export const getUserCompanyId = () => {
  const companyId = localStorage.getItem("u_company_id");
  if (companyId) {
    return companyId;
  } else {
    return null;
  }
}

export const authService = () => {


  async function loginOutlook(instance) {
  try {
    const data = await instance.loginPopup(loginRequest);
    console.warn('*login popup data', data);

    instance.setActiveAccount(data.account);

    localStorage.setItem("session_Exp_tok", data.expiresOn);
    setAuthCookie("u_tk", data.account.idToken);

    return 200;
  } catch (e) {
    console.error("MSAL Error:", e);
    const message = getMsalErrorMsg(e.errorCode || e.code);
    return message;
  }
}

  // async function logOut() {
  //   // close user outlook session

  //   await instance.logoutPopup(
  //     {
  //       postLogoutRedirectUri: "/",
  //       mainWindowRedirectUri: "/",
  //     },
  //     logOuts()
  //   );
  // }

  const logOut = () => {
    localStorage.removeItem("u_name");
    localStorage.removeItem("u_email");
    localStorage.removeItem("u_tk");
    localStorage.removeItem("u_id")
    localStorage.removeItem("_openMods");
    localStorage.removeItem("mod_id");
    localStorage.removeItem("r_token");
    localStorage.removeItem("u_company_id");
    localStorage.removeItem("u_company_name")
    localStorage.removeItem("session_Exp_tok")
    localStorage.removeItem("u_companies")
    localStorage.removeItem("u_account_id");

    sessionStorage.clear();
  };

  const getUsername = () => {
    const name = localStorage.getItem("u_name");
    if (name) {
      return name;
    } else {
      return null;
    }
  };

  const getUserEmail = () => {
    const email = localStorage.getItem("u_email");
    if (email) {
      return email;
    } else {
      return null;
    }
  };



  const getUserToken = () => {
    const token = localStorage.getItem("u_tk");
    if (token) {
      return token;
    } else {
      return null;
    }
  };

  return {
    loginOutlook,
    getUsername,
    getUserEmail,
    getUserToken,
    logOut,
  };
};

export function getPermissions(resourceId) {
  return axios.get(`${environment.getPermissions}?resourceId=${resourceId}`);
}

export function getAcronym(){
  try {
    const name = localStorage.getItem("u_name");
    let split = name?.split(" ") ?? [];
    return split
      .map((word) => word.charAt(0).toUpperCase())
      .join("");
  } catch (error) {
    throw new Error(error);
  }

}

export default authService;
